<style lang="scss" scoped></style>

<template>
  <div
    v-if="errorResponse && errorResponse.errors && errorResponse.errors.length > 0"
    class="bg-red bg-opacity-20 rounded-lg font-normal text-red text-opacity-80 px-[16px] py-[8px] flex flex-row gap-x-2"
  >
    <IconExclamation class="h-6 w-6 fill-current"></IconExclamation>
    <ul class="grid">
      <li v-for="(error, index) in errorResponse.errors" :key="index" class="error-msg">
        {{ customError(error) }}
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from "vue-facing-decorator";
  import { icons } from "@/assets/svg";

  @Component({
    components: {
      IconExclamation: icons.ExclamationIcon,
    },
  })
  export default class FormError extends Vue {
    @Prop() errorResponse?: ErrorResponse;

    customError(error: ServerError | string) {
      if (typeof error === "string") {
        return this.$te(`errors.${error}`) ? this.$t(`errors.${error}`) : error;
      }

      const params = error.params || [];

      //TODO: move this to something abstract.
      if (error.message === "validation.exists" && params.includes("whise_id")) {
        return "Account heeft geen geldig Whise ID.";
      }

      if (error.message === "validation.exists" && params.includes("activities") && params.includes("id") && params.includes("office_id")) {
        return "Je hebt niet de juiste rechten om een aanpassing te doen binnen dit kantoor.";
      }

      return this.$te(`errors.${error.message}`)
        ? this.$t(`errors.${error.message}`, [this.$te(`errors.fields.${error.field}`) ? this.$t(`errors.fields.${error.field}`) : error.field, ...(error.params || [])])
        : error.message;
    }
  }
</script>
